import { useDataChange, useDataValue } from 'Simple/Data.js'
import { PAYMENT_ACCOUNT_TYPES } from 'Data/constants.js'

export function isSelected(payors, payor) {
  if (!payor || !payors) return false

  return payors.some(p => {
    if (payor.account_type === PAYMENT_ACCOUNT_TYPES.Person) {
      return (
        p.account_type === PAYMENT_ACCOUNT_TYPES.Person &&
        p.payment_account_id === payor.payment_account_id
      )
    } else {
      return (
        p.account_type === PAYMENT_ACCOUNT_TYPES.Insurance &&
        p.payment_account_id === payor.payment_account_id &&
        p.insured_id === payor.insured_id
      )
    }
  })
}

export function useOnClick(props) {
  let change = useDataChange({
    context: 'tab',
    viewPath: props.viewPath,
  })
  let payor = useDataValue({
    context: 'payor',
    viewPath: props.viewPath,
  })

  return function onClick() {
    change(next => {
      let index = next.selected.ledger.payors.findIndex(p => {
        if (payor.account_type === PAYMENT_ACCOUNT_TYPES.Person) {
          return (
            p.account_type === PAYMENT_ACCOUNT_TYPES.Person &&
            p.payment_account_id === payor.payment_account_id
          )
        } else {
          return (
            p.account_type === PAYMENT_ACCOUNT_TYPES.Insurance &&
            p.payment_account_id === payor.payment_account_id &&
            p.insured_id === payor.insured_id
          )
        }
      })

      if (index !== -1) {
        next.selected.ledger.payors.splice(index, 1)
      } else {
        next.selected.ledger.payors.push({
          account_type: payor.account_type,
          payment_account_id: payor.payment_account_id,
          insured_id: payor.insured_id || null,
        })
      }
    })
  }
}
